import { render, staticRenderFns } from "./BaseAttachment.vue?vue&type=template&id=421cfd2c&scoped=true"
import script from "./BaseAttachment.vue?vue&type=script&lang=js"
export * from "./BaseAttachment.vue?vue&type=script&lang=js"
import style0 from "./BaseAttachment.vue?vue&type=style&index=0&id=421cfd2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421cfd2c",
  null
  
)

export default component.exports